import React, {useEffect, useState} from 'react';
import {Text, Pressable} from 'react-native';
import {COLORS} from '../../../utils/Constants';
import {tID} from '../../../utils/TestIdHelper';
import CachedImage from '../../elements/CachedImage';
import styles from './styles';

const UserAvatar = ({size, radius, name = '', source, onPress}) => {
  const [bgColor, setBGColor] = useState(COLORS.blueMain1);
  const nameArray = name ? name.split(' ') : [];
  let initial = '';
  if (nameArray.length > 1) {
    initial = nameArray[0].charAt(0) + nameArray[1].charAt(0);
  } else {
    initial = name.substring(0, 2);
  }

  useEffect(() => {
    let initChar = initial ? initial.charAt(0).toUpperCase() : '';
    switch (true) {
      case /[A-D]/.test(initChar):
        setBGColor(COLORS.mainDarkText);
        break;
      case /[E-H]/.test(initChar):
        setBGColor(COLORS.blueMain3);
        break;
      case /[I-M]/.test(initChar):
        setBGColor(COLORS.purple);
        break;
      case /[N-Q]/.test(initChar):
        setBGColor(COLORS.pink);
        break;
      case /[R-V]/.test(initChar):
        setBGColor(COLORS.secondaryBlue);
        break;
      case /[W-Z]/.test(initChar):
        setBGColor(COLORS.grey1);
        break;
    }
  }, [initial]);

  return (
    <Pressable
      testID={tID('UserAvatar-Pressable-Main')}
      style={styles.container(size, radius, bgColor)}
      onPress={onPress}>
      {source && (
        <CachedImage source={source} style={styles.imageStyle(size)} />
      )}
      {!source && name.length > 0 && (
        <Text
          testID={tID('UserAvatar-Text-Initials')}
          style={styles.initialText(size)}>
          {initial}
        </Text>
      )}
    </Pressable>
  );
};

export default UserAvatar;
